<template>
  <v-dialog
    v-model="dialog"
    width="450"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-if="!false"
        v-bind="attrs"
        link
        class="pr-0 pl-12"
        v-on="on"
      >
        <v-list-item-content class="py-0">
          <v-list-item-title>Приходы</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card class="dialogBackground">
      <v-row
        no-gutters
        class="dialogTitleBackground white--text px-2 py-1 mb-2"
        align="center"
      >
        <span>Отчёт по приходам</span>
        <v-spacer />
        <v-btn
          small
          icon
          dark
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <v-card-text>
        <v-row dense>
          <span>Выберите период, за который должен быть сформирован отчёт</span>
        </v-row>
        <v-row
          dense
          class="mt-8"
        >
          <v-col>
            <PeriodSelector
              v-model="period"
              dense
              :error-messages="objectErrors(this.$v.period.dateFrom).concat(objectErrors(this.$v.period.dateTo))"
              @input="$v.period.dateFrom.$touch(); $v.period.dateTo.$touch()"
              @blur="$v.period.dateFrom.$touch(); $v.period.dateTo.$touch()"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <FileTypeSelector v-model="fileType" />
          <v-col v-if="!this.$store.state.auth.user.cargoTypeID">
            <CargoTypeSelector
              v-model="cargoTypeID"
              :error-messages="objectErrors(this.$v.cargoTypeID)"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="px-12"
          color="primary"
          :loading="loading"
          @click.prevent="okClick"
        >
          ОК
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PeriodSelector from "@/components/PeriodSelector"
import CargoTypeSelector from "@/components/CargoTypeSelector"
import FileTypeSelector from "@/components/FileTypeSelector.vue"
import { required } from "vuelidate/lib/validators"

export default {
  components: {
    PeriodSelector,
    CargoTypeSelector,
    FileTypeSelector
  },

  data: () => ({
    dialog: false,
    period: { dateFrom: null, dateTo: null },
    cargoTypeID: 0,
    fileType: "pdf",
    loading: false
  }),

  watch: {
    dialog() {
      this.$v.$reset()
    }
  },

  validations() {
    return {
      period: { dateFrom: { required }, dateTo: { required } },
      cargoTypeID: { required }
    }
  },

  methods: {
    objectErrors(obj) {
      if (!obj.$dirty) return []
      const errors = []

      obj.$params.required && !obj.required && errors.push("Задайте период")
      return errors
    },

    async okClick() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }

      try {
        this.loading = true
        const response = await this.axios.get("/reports/income", {
          params: {
            dateFrom: this.period.dateFrom,
            dateTo: this.period.dateTo,
            cargoTypeID: this.$store.state.auth.user.cargoTypeID
              ? this.$store.state.auth.user.cargoTypeID
              : this.cargoTypeID,
            fileType: this.fileType
          }
        })
        window.open(response.data, "_blank")
        this.dialog = false
      } catch (err) {
        this.$notify(
          "error",
          err.response?.data?.message ? err.response.data.message : "Ошибка при формировании отчёта"
        )
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
